import React from 'react'
import { TagWithVisible } from 'cityads-v3/types/tag'
import { getLuminance, useTheme } from '@mui/material'
import classes from './OfferFilterCheckbox.scss'

import Checkbox, { CheckboxProps } from '@mui/material/Checkbox'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

type OfferFilterCheckboxProps = Partial<TagWithVisible> & {
  checked: boolean,
  onChange?: CheckboxProps['onChange'],
  onToggle?: (evt: React.MouseEvent) => void
}
export default function OfferFilterCheckbox(props: OfferFilterCheckboxProps): JSX.Element {
  const theme = useTheme()
  const backgroundColor = props.filter_bg_color || (theme.palette.mode === 'dark' ? 'rgba(128,128,128,0.08)' : '#f5f5f5')
  const isBackgroundDark = getLuminance(backgroundColor) < 0.5
  const textColor = props.filter_text_color || theme.palette.getContrastText(backgroundColor || '#fff')

  const checkboxColor = isBackgroundDark
    ? textColor
    : undefined

  return (
    <ListItem
      data-item
      key={props.code}
      sx={{
        background: backgroundColor,
        color: textColor,
        p: 0,
      }}
      secondaryAction={
        props.icon?.[0]?.source
          ? (<img src={props.icon[0].source} className={classes.filterListItemSecondaryIcon} alt={props.title} />)
          : null
      }
    >
      <ListItemButton onClick={props.onToggle} sx={{ pl: '8px' }}>
        <ListItemIcon classes={{ root: classes.filterListItemIcon }}>
          <Checkbox
            style={{ color: checkboxColor }}
            slotProps={{
              input: {
                name: props.code,
              }
            }}
            checked={props.checked}
            onChange={props.onChange}
          />
        </ListItemIcon>
        <ListItemText
          primary={props.title}
          classes={{
            root: classes.filterListItemTextRoot,
            primary: classes.filterListItemText
          }}
        />
      </ListItemButton>
    </ListItem>
  )
}
